import React, {Component} from 'react';
import {connect} from 'react-redux';
import Modal from '../../components/Modal';
import {WithContext as ReactTags} from 'react-tag-input';
import correoValidators from './correoValidators';
import {displayValidationErrors, isFormValid, resetValidators} from "../../utils/validateForm";

const emailRegEx = /^(([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+)(([\s]*[;,]+[\s]*(([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+))*)$/;

class EnviarCorreo extends Component {
    constructor(props, context) {
        super(props, context);


        this.handleShow = this.handleShow.bind(this);
        this.handleHide = this.handleHide.bind(this);
        this.state = {
            comentario: '',
            enviarPdf: true,//Req 92528 ebarboza 30 08 2021
            enviarXml: true,
            tags: [],
            copia: [],
            suggestions: [],
            isFormValided: false,
            isOpen: true,
            listaCorreos:[]//Req 92528 ebarboza 30 08 2021
        };
        this.enviarCorreoIntern = this.enviarCorreoIntern.bind(this);
        this.onChangeValue = this.onChangeValue.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleInputBlur = this.handleInputBlur.bind(this); // <86111> ivelasquez 12/03/2021
        this.handleDrag = this.handleDrag.bind(this);
        this.onChangeComentarioInput = this.onChangeComentarioInput.bind(this);
        this.handleDeleteCopia = this.handleDeleteCopia.bind(this);
        this.handleAdditionCopia = this.handleAdditionCopia.bind(this);
        this.handleDragCopia = this.handleDragCopia.bind(this);
        this.handleTagClick = this.handleTagClick.bind(this);
        /*Inicio Req 92528 ebarboza 27 08 2021 */
        this.copiarPortaPapeles = this.copiarPortaPapeles.bind(this)
        this.copiarPortaPapelesAdd = this.copiarPortaPapelesAdd.bind(this)
        /*Fin Req 92528 ebarboza 27 08 2021 */

        this.validators = correoValidators;
    }


    componentDidMount() {
        resetValidators(this.validators);
        var dataRows = [];
        var emailList = [];

        this.props.registros && this.props.registros.forEach((item) => {
            if (item.correo && !(emailList.indexOf(item.correo)>=0)) {
                emailList.push(item.correo);
            }
        });

        if (this.props.domain) {
            if (this.props.domain.correo && !(emailList.indexOf(this.props.domain.correo)>=0)) {
                emailList.push(this.props.domain.correo);
            }
        }
        ;

        emailList.forEach((item) => {
            dataRows.push({id: dataRows.length, text: item});
        });
        this.setState({tags: dataRows});
        if (dataRows.length > 0) {
            var data = {'target': {value: 'test'}};
            this.handleInputChange(data, 'tags');
        }

    }

    /*Inicio Req 92528 ebarboza 27 08 2021 */
    closeModal = () => {
        this.setState({isOpen: false});
    };
    copiarPortaPapeles = (e) => {
        if (!emailRegEx.test(e)) {
            let data = {'target': {value: ''}};
            this.handleInputChange(data, 'tags');
            return;
        }
        let tags = this.state.tags.filter(tag => {return tag.text != e})
        tags = [...tags, {id: tags.length + 1, text: e}]
        this.setState({tags: tags});      
     }

     copiarPortaPapelesAdd = (e) => {
        if (!emailRegEx.test(e)) {
            let data = {'target': {value: ''}};
            this.handleInputChange(data, 'tags');
            return;
        }
        let copia = this.state.copia.filter(copia => {return copia.text != e})
        copia = [...copia, {id: copia.length + 1, text: e}]
        this.setState({copia: copia});      
     }
    /*Fin Req 92528 ebarboza 27 08 2021 */

    handleInputChange = (e, field, exclude) => {
        const validator = this.validators[field];
        if(validator) {
            validator.state = (e !== null && !exclude ? e.target.value : '');
            validator.exclude = (typeof(exclude) === 'undefined' || exclude === null ? false : exclude);
            this.onChangeFormValidation();
        }
    };

    handleDelete(i) {
        this.setState({
            tags: this.state.tags.filter((tag, index) => index !== i),
        });
        var data = {'target': {value: ''}};
        if ((this.state.tags.length - 1) !== 0) {
            data = {'target': {value: 'test'}};
        }
        this.handleInputChange(data, 'tags');
    }

    handleInputBlur(tag) {
        if (!emailRegEx.test(tag)) {
            let data = {'target': {value: ''}};
            this.handleInputChange(data, 'tags');
            return;
        }

        let {tags} = this.state;
        this.setState({tags: [...tags, {id: tags.length + 1, text: tag}]});
        let data = {'target': {value: tag}};
        this.handleInputChange(data, 'tags');
    }

    /*handleAddition(tag) {
        if (!emailRegEx.test(tag)) {
            var data = {'target': {value: ''}};
            this.handleInputChange(data, 'tags');
            return;
        }

        let {tags} = this.state;
        this.setState({tags: [...tags, {id: tags.length + 1, text: tag}]});
        var data = {'target': {value: tag}};
        this.handleInputChange(data, 'tags');
    }*/

    enviarCorreoIntern = () => {
        if (this.state.isFormValided || this.state.tags.length > 0) {
            this.props.enviarCorreo(
                {
                    mensaje: this.state.comentario,
                    destinatario: this.state.tags,
                    copia: this.state.copia,
                    item: this.props.domain,
                    enviarXml: this.state.enviarXml,
                    enviarPdf: this.state.enviarPdf,
                    tipoCorreo: 'facturacion'
                });
                this.closeModal()
        }
    };
    onChangeFormValidation = () => {
        this.setState({isFormValided: isFormValid(this.validators)});
    }

    handleDrag(tag, currPos, newPos) {
        const tags = [...this.state.tags];

        // mutate array
        tags.splice(currPos, 1);
        tags.splice(newPos, 0, tag);

        // re-render
        this.setState({tags});
    }

    handleDeleteCopia(i) {
        this.setState({
            copia: this.state.copia.filter((tag, index) => index !== i),
        });
    }

    handleAdditionCopia(tag) {
       // <I 86111> ivelasquez 12/03/2021
       if (!emailRegEx.test(tag)) {
        let data = {'target': {value: ''}};
        this.handleInputChange(data, 'copia');
        return;
    }
    // <F 86111> ivelasquez 12/03/2021
    let {copia} = this.state;
    this.setState({copia: [...copia, {id: copia.length + 1, text: tag}]});
    }

    handleDragCopia(tag, currPos, newPos) {
        const tags = [...this.state.copia];

        // mutate array
        tags.splice(currPos, 1);
        tags.splice(newPos, 0, tag);

        // re-render
        this.setState({tags});
    }

    onChangeComentarioInput(e) {
        this.setState({comentario: e.target.value});
        this.handleInputChange(e, 'comentario');
    }

    onChangeValue = e => {
        this.setState({[e.target.name]: e.target.checked})
    }

    handleShow() {
        this.setState({show: true});
    }

    handleHide() {
        this.setState({show: false});
    }

    handleTagClick(index) {
        console.log('The tag at index ' + index + ' was clicked');
    }

    render() {
        const {tags, copia, suggestions} = this.state;

        var DefaultClassNames = {
            tag: "pill pill-cyan pillSelct-pills-item ng-binding ng-scope",
        };
        return (
            <div>
                {this.state.isOpen === true &&
                <div>
                <Modal idModal='enviar-correo' modalSize='modal-dialog' title='Enviar Correo SUNARP'
                       closeModal={this.props.closeModal}
                       isOpen
                >
                    <div>
                        <div className='form-group'>
                            <label className='labelInfo'> Correos</label>
                            <ReactTags
                                tags={tags}
                                placeholder={"Ingrese un correo"}
                                suggestions={suggestions}
                                classNames={DefaultClassNames}
                                handleDelete={this.handleDelete}
                                handleInputBlur={this.handleInputBlur} // <86111> ivelasquez 12/03/2021
                                handleAddition = {e => this.copiarPortaPapeles(e)} // Req 92528 ebarboza 27 08 2021
                                handleDrag={this.handleDrag}
                                handleTagClick={this.handleTagClick}
                            />
                            {this.state.tags.length > 0?null:displayValidationErrors(this.validators, 'tags')}
                        </div>
                        <div className='form-group'>
                            <label className='labelInfo'> Correos Adicionales</label>
                            <ReactTags
                                tags={copia}
                                suggestions={suggestions}
                                placeholder={"Ingrese un correo"}
                                classNames={DefaultClassNames}
                                handleDelete={this.handleDeleteCopia}
                                handleInputBlur={this.handleAdditionCopia} // <86111> ivelasquez 12/03/2021
                                handleAddition={this.copiarPortaPapelesAdd}
                                handleDrag={this.handleDragCopia}
                                handleTagClick={this.handleTagClick}
                            />

                        </div>
                        <div className='form-group'>
                            <label className='labelInfo'>Texto Correo
                            </label>
                            <textarea
                                className='form-control' value={this.state.comentario}
                                onChange={this.onChangeComentarioInput}
                                placeholder='Ingresa tus comentarios acá'
                            />
                        </div>
                        <div className='form-group'>
                            <label className='labelInfo'>Adjuntar</label>
                            <div className='col-md-10'>
                                <div className='col-md-4'>
                                    <label>XML</label>
                                    <input type="checkbox" readOnly={true} onChange={this.onChangeValue}
                                           checked={this.state.enviarXml}
                                           name="enviarXml"
                                    />
                                </div>
                                <div className='col-md-4'>
                                    <label>PDF</label>
                                    <input type="checkbox" checked={this.state.enviarPdf} onChange={this.onChangeValue}
                                           name="enviarPdf"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='modal-actions'>
                        <button className='btn btn-primary pull-right'
                                onClick={() => this.enviarCorreoIntern()}>Enviar
                        </button>
                    </div>
                </Modal>
                </div>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {};
}


EnviarCorreo.defaultProps = {};
export default connect(mapStateToProps,
    {})(EnviarCorreo);



// WEBPACK FOOTER //
// ./src/pages/Inmatriculacion/enviarCorreo.js